import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export const OVERVIEW_TAB_INDEX = 0;
export const ORDER_FORMS_TAB_INDEX = 1;
export const WORK_ORDERS_TAB_INDEX = 2;

@Injectable({
  providedIn: 'root',
})
export class OrdersEditTabService {
  private selectedTabIndex$$ = new BehaviorSubject<number>(OVERVIEW_TAB_INDEX);

  get selectedTabIndex$(): Observable<number> {
    return this.selectedTabIndex$$.asObservable();
  }

  setSelectedTabIndex(index: number): void {
    this.selectedTabIndex$$.next(index);
  }

  navigateToWorkOrdersTab(): void {
    this.selectedTabIndex$$.next(WORK_ORDERS_TAB_INDEX);
  }

  navigateToOrderFormsTab(): void {
    this.selectedTabIndex$$.next(ORDER_FORMS_TAB_INDEX);
  }
}
